import * as React from 'react';
import DOMPurify from 'dompurify';
import { decode } from 'he';

import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import BusinessCenterOutlinedIcon from '@material-ui/icons/BusinessCenterOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import MessageOutlinedIcon from '@material-ui/icons/MessageOutlined';
import DirectionsIcon from '@material-ui/icons/Directions';
import FeedbackOutlinedIcon from '@material-ui/icons/FeedbackOutlined';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import ListAltRoundedIcon from '@material-ui/icons/ListAltRounded';
import { GetUserMessage, GetFileData, UserRxFormData } from 'src/reducers/rxForm';
import Files from 'react-files';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import ScrollToBottom from 'react-scroll-to-bottom';
import {
    IconButton,
    DialogProps,
    DialogTitle,
    Dialog,
    DialogContent,
    FormControlLabel,
    Checkbox,
    FormControl,
    Select,
    MenuItem,
    DialogActions,
    Tooltip,
    Divider,
    CardContent
} from '@material-ui/core';
import ThreeDRotationIcon from '@material-ui/icons/ThreeDRotation';
import { UserDetail } from 'src/reducers/user';
import DeleteIcon from '@material-ui/icons/Delete';
import { RedesignReasons } from 'src/reducers/completeorderfile';
import { ManufacturerData, TatData } from 'src/reducers/fileUpload';
import RedoIcon from '@material-ui/icons/Redo';
import ThumbsUpDownRoundedIcon from '@material-ui/icons/ThumbsUpDownRounded';
import RefreshIcon from '@material-ui/icons/Refresh';
import PlayCircleFilledTwoToneIcon from '@material-ui/icons/PlayCircleFilledTwoTone';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import Previewform from './PreviewForm';
// import './rxstyles.css';
import DialogContentText from '@material-ui/core/DialogContentText';
import RestoreIcon from '@material-ui/icons/Restore';

export interface RxorderformViewprops {
    userDetails: UserDetail;

    orderno: string;
    filename: string;
    filepath: string;
    createddate: string;
    destination: string;
    designername: string;
    fqcname: string;
    mdesignername: string;
    designapproval: string;
    modelonly: string;
    bravo: string;
    fdownload: string;
    qc_required: string;
    downloadedon: string;
    completedon: string;
    duedate: string;
    lab: string;
    customerstatus: string;
    vfiles: string;
    status: string;
    caseNotes: string;
    tool_preferred: string;
    rxDetails: UserRxFormData[];
    designtype: string;
    notations: string;
    product: string;
    model: string;
    getMessage: GetUserMessage[];
    customer: string;
    feedback: string;
    refno: string;
    drpref: string;
    onSubmit: () => void;
    messaging: (message: string) => void;
    messages: string;
    downloadFile: (filepath: string, filename: string, status: string, ociStatus: string, orderno: string) => void;
    onFeedback: () => void;
    onViewFeedback: () => void;  
    onFilesChange: (messageFiles: Array<File>) => void;
    onFilesError: (error: Error, images: Array<File>) => void;
    getApiMessage: () => void; // not used inside code.
    msgAtt: (msgAttachment: string, ociStatus: string) => void;
    getFilesData: GetFileData[];
    goStlViewer: (data: GetFileData[]) => void;

    // bookingId: string;
    // drPreferences: string;

    getRxDetails: () => void;
    getFiles: () => void;
    getMessages: () => void;
    messageFiles: Array<File>;

    redesignReasons: RedesignReasons[];
    orderDataTat: TatData[];
    orderDataManufacturer: ManufacturerData[];
    redesignRequest: (columns: Object) => void;
    supportPage: (order: string) => void;

    openVideoPlayerURL: (fullPath: GetFileData[]) => void;
    openVideoPlayerURLArray: (fullPath: string[], fpath: string) => void;

    approvalRequired: (array: Array<object>) => void;

    verticalViewScreen: boolean;

    submitRework: (column: Object) => void;
}
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

interface SubitReDesignCodes {
    producttype: string;
    category: string;
    reason: string;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </Typography>
    );
}

function a11yProps(index: number) {
    return {
        id: `nav-tab-${index}`,
        'aria-controls': `nav-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        drPreferencesContent: {
            padding: theme.spacing(2),
            overflowY: 'auto',
        },
        paper: {
            margin: theme.spacing(1, 5),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        paperNs: {
            margin: theme.spacing(1),
            boxShadow: theme.shadows[0],
            // display: 'flex',
            // flexDirection: 'column',
            // alignItems: 'center',
        },
        avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main,
        },
        avatarNs: {
            margin: theme.spacing(1, 0),
            width: theme.spacing(4),
            height: theme.spacing(4),
            backgroundColor: theme.palette.secondary.main,

        },
        form: {
            width: '100%', // Fix IE 11 issue.
            marginTop: theme.spacing(1),
            textAlign: 'center'
        },
        formNs: {
            width: '100%',
            textAlign: 'center'
        },
        submit: {
            // margin: theme.spacing(3, 0, 2),
            fontSize: '16px',
            fontWeight: 100,
            textTransform: 'capitalize'
        },
        table: {
            minWidth: '100%',
        },
        tableMargin: {
            marginTop: theme.spacing(2),
        },
        tabpanel: {
            margin: theme.spacing(2, 0),
            maxHeight: '260px',
            overflowY: 'auto'
        },
        buttonColor: {
            backgroundColor: '#23a710e6',
            color: '#fff',
            fontWeight: 500,
            '& :hover': {
                color: '#000'
            }
        },
        container: {
            bottom: 0,
            height: '240px',
            overflow: 'auto'
            // position: "fixed" // remove this so we can apply flex design
        },
        containerNs: {
            height: '370px',
            overflow: 'auto'
        },
        bubbleContainer: {
            width: '100%',
            display: 'flex' // new added flex so we can put div at left and right side
            // check style.css for left and right classNamenaeme based on your data
        },
        bubble: {
            display: 'inline-block',
        },
        bubbleReciver: {
            display: 'inline-block',
        },
        right: {
            textAlign: 'right',
            margin: '12px 12px'
        },
        left: {
            textAlign: 'left',
            margin: '12px 12px'
        },
        message: {
            fontWeight: 500
        },
        date: {
            fontSize: '12px'
        },
        imageHeight: {
            height: '50px'
        },
        mfrom: {
            fontWeight: 'bolder',
            color: '#4F93FE'
        },
        mto: {
            fontWeight: 'bolder',
            color: '#38C7D8'
        },
        filesDropzoneActive: {
            border: '3px solid #3f51b5',
            color: '#3f51b5',
        },
        fileUpload: {
            // margin: theme.spacing(1),
            textAlign: 'center',
            // fontSize: '10px',
            // borderRadius: '30%',
            // color: '#808080',
            height: '5.5vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // borderStyle: 'dotted',
            transition: 'all 1s',
            '&:hover': {
                color: '#3f51b5',
                border: '2px solid #3f51b5'
            },
        },
        textField: {
            margin: '0px !important'
        },
        chatBotWidth: {
            width: '50%'
        },
        attachment: {
            fontSize: '12px',
            cursor: 'pointer',
            '&:hover': {
                cursor: 'pointer',
                color: '#3F51B5'
            },
        },
        heading: {
            fontSize: theme.typography.pxToRem(15),
            fontWeight: theme.typography.fontWeightRegular,
        },
        fileHover: {
            cursor: 'pointer',
            color: '#3F51B5',
            '&:hover': {
                cursor: 'pointer',
                color: '#3F51B5'
            },
        },
        fileHoverNs: {
            cursor: 'pointer',
            color: '#3F51B5',
            fontSize: '0.9rem',
            '&:hover': {
                cursor: 'pointer',
                color: '#3F51B5'
            },
        },
        colorDel: {
            color: 'red',
            cursor: 'pointer'
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        reasonBox: {
            minWidth: '500px'
        },
        previewOrderfont: {
            fontSize: '12px',
            display: 'grid'
        },
        filenameanddate: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        downloadStatusIconGreen: {
            width: '20px',
            height: '20px',
            background: 'green',
            borderRadius: '50%',
            padding: '5px',
            zIndex: 2,
            position: 'relative',
            float: 'right',
            marginLeft: '-25px',
            marginTop: '10px'
        },
        downloadStatusIconRed: {
            width: '20px',
            height: '20px',
            background: 'red',
            borderRadius: '50%',
            padding: '5px',
            zIndex: 2,
            position: 'relative',
            float: 'right',
            marginLeft: '-25px',
            marginTop: '10px'
        },
        tableRowNs: {
            '&:last-child th, &:last-child td': {
                borderBottom: 0
            },
        },
        tableContainerNs: {
            // border: '1px solid #eee',            boxShadow: theme.shadows[0],
            overflowY: 'hidden',
            '&::-webkit-scrollbar': {
                width: '0.4em',
                height: '0.5em',
            },
            '&::-webkit-scrollbar-track': {
                '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgb(0 0 0 / 42%)',
                // outline: '1px solid slategrey'                borderRadius: '50px',
            },
        },
        cardFieldsNs: {
            margin: theme.spacing(0, 0, 1, 0),
        },
        cardMarginNs: {
            margin: theme.spacing(0, 0, 1, 1),
        },
        cardMargin2Ns: {
            margin: theme.spacing(0, 1, 1, 0),
        },
        instructionNs: {
            height: 130,
            overflow: 'overlay',
            '&::-webkit-scrollbar': {
                width: '0.4em',
            },
            '&::-webkit-scrollbar-track': {
                '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgb(0 0 0 / 42%)',
                // outline: '1px solid slategrey'                borderRadius: '50px',
            },
        },
        scrollStyleNs: {
            overflowX: 'hidden',
            '&::-webkit-scrollbar': {
                width: '0.4em',
            },
            '&::-webkit-scrollbar-track': {
                '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgb(0 0 0 / 42%)',
                // outline: '1px solid slategrey'                borderRadius: '50px',
            },
        },
        centerNs: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        cssOutlinedInput: {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#fff !important',
            },
        },
        qcreq: {
            position: 'absolute',
            fontSize: '10px',
            bottom: '5px',
            right: '5px',
            fontStyle: 'italic',
            color: 'red'
        },
        button: {
            margin: theme.spacing(1),
        },
    })
);

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
            fontSize: '0.9rem'
        }
    },
})(TextField);

const CardHeaderCss = withStyles({
    root: {
        '& .MuiCardHeader-title': {
            // textAlign: 'center',
            fontSize: '25px',
            fontWeight: 500
        },
        '& .MuiCardHeader-action': {
            marginTop: '0px'
        },
        padding: '0 16px'
    },
})(CardHeader);

const CardHeaderCssNs = withStyles({
    root: {
        '& .MuiCardHeader-title': {
            // textAlign: 'center',
            fontSize: 20,
            fontWeight: 400
        },
        '& .MuiCardHeader-action': {
            alignSelf: 'center',
        },
        padding: '0 16px'
    },
})(CardHeader);

const CardHeaderCssInside = withStyles({
    root: {
        '& .MuiCardHeader-title': {
            // textAlign: 'center',
            fontSize: 18,
            fontWeight: 400
        },
        padding: '8px 16px 8px 16px'
    },
})(CardHeader);

const CardHeaderCssFiles = withStyles({
    root: {
        '& .MuiCardHeader-title': {
            // textAlign: 'center',
            fontSize: 16,
            fontWeight: 400
        },
        padding: 8,
        '& .MuiCardHeader-action': {
            margin: 0,
        },
        '& .MuiCardContent-root': {
            margin: 0,
        },
    },
})(CardHeader);

const CardContentFiles = withStyles({
    root: {
        padding: '0 8px 8px 8px !important',
    },
})(CardContent);

const AntTab = withStyles({
    root: {
        textTransform: 'none',
    }
})(Tab);

const RxorderFormView: React.StatelessComponent<RxorderformViewprops> = (props) => {
    const classes = useStyles({});

    const [openViewManufact] = React.useState(false);
    const [openViewManufactFileRef, setOpenViewManufactFileRef] = React.useState(false);
    // const [openViewManufact, setOpenViewManufact] = React.useState((props.userDetails.ugroup === 'Manufacturer' || props.userDetails.ugroup === 'EDDL') ? true : false);
    // const [openViewManufactFileRef, setOpenViewManufactFileRef] = React.useState((props.userDetails.ugroup === 'Manufacturer' || props.userDetails.ugroup === 'EDDL') ? true : false);
    const decodedDrpref = decode(props.drpref || '');

    const sanitizedDrpref = DOMPurify.sanitize(decodedDrpref, {
        ALLOWED_TAGS: [
            'p',
            'br',
            'span',
            'strong',
            'em',
            'u',
            's',
            'ol',
            'ul',
            'li',
        ],
        ALLOWED_ATTR: ['style'],    
    });
    const [value, setValue] = React.useState(0);
    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
        switch (newValue) {
            case 0:
                props.getRxDetails();
                break;
            case 1:
                props.getFiles();
                break;
            case 3:
                props.getMessages();
                break;
            default:
                break;
        }
    };

    let fileTypes: string[] = ['Initial Scan', 'Quality Image', 'Others'];

    switch (props.status) {
        case '10':
            fileTypes = ['Initial Scan', 'STL File', 'PTS/3OX Files', 'Quality Image', 'Final Scan', 'Video', 'Others'];
            break;
        case '14':
            if ((props.userDetails.ugroup === 'Manufacturer' || props.userDetails.ugroup === 'EDDL')) {
                fileTypes = ['Initial Scan', 'STL File', 'PTS/3OX Files', 'Quality Image', 'Final Scan', 'Others'];
            } else if (props.userDetails.ugroup === 'Lab') {
                fileTypes = ['Initial Scan', 'STL File', 'PTS/3OX Files', 'Quality Image', 'Final Scan', 'Video', 'Others'];
            }
            break;
        default:
            fileTypes = ['Initial Scan', 'Quality Image', 'Video', 'Others'];
    }

    const fileRender1 = (fileType: string) => {
        if ((fileType !== 'PTS/3OX Files' && fileType !== 'STL File')) {
            const filteredFiles = props.getFilesData.filter(uniquefiles => uniquefiles.filetype === fileType);

            if (filteredFiles.length > 0) {
                return filteredFiles.map((r, index) => (
                    <div key={index} className={classes.filenameanddate}>
                        <Typography
                            key={`id_${index}`}
                            onClick={
                                () => props.downloadFile(r.filename.replace(`/${r.filename.split('/').reverse()[0]}`, ''), r.filename.split('/').reverse()[0], fileType, r.oci_status, props.orderno)}
                            className={props.verticalViewScreen ? classes.fileHoverNs : classes.fileHover}
                            variant={openViewManufact ? 'overline' : 'body1'}
                        >
                            {r.filename.split('/').reverse()[0]}
                        </Typography>
                        <Typography variant="caption" color="textSecondary"> -&nbsp;{r.createdon} </Typography>
                    </div>
                )
                );
            }
            return 'No Data';
        } else if (fileType === 'PTS/3OX Files') {
            const filteredFiles = props.getFilesData.filter(uniquefiles => (uniquefiles.filename.split('.').reverse()[0] === 'pts' || uniquefiles.filename.split('.').reverse()[0] === '3ox'));

            if (filteredFiles.length > 0) {
                return filteredFiles.map((r, index) => (
                    <div key={index} className={classes.filenameanddate}>
                        <Typography
                            key={`id_${index}`}
                            onClick={
                                () => props.downloadFile(r.filename.replace(`/${r.filename.split('/').reverse()[0]}`, ''), r.filename.split('/').reverse()[0], fileType, r.oci_status, props.orderno)}
                            className={props.verticalViewScreen ? classes.fileHoverNs : classes.fileHover}
                            variant={openViewManufact ? 'overline' : 'body1'}
                        >
                            {r.filename.split('/').reverse()[0]}
                        </Typography>
                        <Typography variant="caption" color="textSecondary"> -&nbsp;{r.createdon} </Typography>
                    </div>
                )
                );
            }
            return 'No Data';
        } else if (fileType === 'STL File') {
            const filteredFiles = props.getFilesData.filter(uniquefiles => (uniquefiles.filetype === fileType && uniquefiles.filename.split('.').reverse()[0] === 'stl'));

            if (filteredFiles.length > 0) {
                return filteredFiles.map((r, index) => (
                    <div key={index} className={classes.filenameanddate}>
                        <Typography
                            key={`id_${index}`}
                            onClick={
                                () => props.downloadFile(r.filename.replace(`/${r.filename.split('/').reverse()[0]}`, ''), r.filename.split('/').reverse()[0], fileType, r.oci_status, props.orderno)}
                            className={props.verticalViewScreen ? classes.fileHoverNs : classes.fileHover}
                            variant={openViewManufact ? 'overline' : 'body1'}
                        >
                            {r.filename.split('/').reverse()[0]}
                        </Typography>
                        <Typography variant="caption" color="textSecondary"> -&nbsp;{r.createdon} </Typography>
                    </div>
                )
                );
            }
            return 'No Data';
        }
        return 'No Data';
    };

    const chatBubbles = Array.isArray(props.getMessage) && props.getMessage.map((obj, i) => (
        <ScrollToBottom key={i}>
            <div>
                {props.customer === obj.mfrom ?
                    <div className={classes.right}>
                        <div key={i++} className={classes.bubble}>
                            <img src="/assets/lab.png" className={classes.imageHeight} />
                            <div className={classes.mfrom}>{obj.mfrom}</div>
                        </div>
                        <div key={i++} className={classes.message}>
                            <div>{obj.message}</div>
                        </div>
                        <div key={i++} className={classes.date}>
                            <div>{obj.mdate}</div>
                        </div>
                        {/* {obj.attachfilename !== '' ?
                            <div onClick={() => props.msgAtt(obj.attachfilename, obj.oci_status)} key={i++} className={classes.attachment}>
                                <div>{obj.attachfilename.split('/').reverse()[0]}</div>
                            </div>
                            :
                            null
                        } */}
                        {
                            obj.attachfilename !== '' ? (
                                <div className={classes.attachment}>
                                    <Previewform file={obj} />
                                </div>
                            ) :
                                null
                        }
                        {
                            Array.isArray(obj.attachments) && obj.attachments.length > 0 && obj.attachments.map((attachment, index) => (
                                <div className={classes.attachment}>
                                    <Previewform file={attachment} />
                                </div>
                            ))
                        }
                    </div>
                    : <div className={classes.left}>
                        <div key={i++} className={classes.bubbleReciver}>
                            <img src="/assets/designer.png" className={classes.imageHeight} />
                            <div className={classes.mto}>{obj.mfrom}</div>
                        </div>
                        <div key={i++} className={classes.message}>
                            <div>{obj.message}</div>
                        </div>
                        <div key={i++} className={classes.date}>
                            <div>{obj.mdate}</div>
                        </div>
                        {/* {obj.attachfilename !== '' ?
                            <div onClick={() => props.msgAtt(obj.attachfilename, obj.oci_status)} key={i++} className={classes.date}>
                                <div>{obj.attachfilename.split('/').reverse()[0]}</div>
                            </div>
                            :
                            null
                        } */}
                        {
                            obj.attachfilename !== '' ? (
                                <div className={classes.attachment}>
                                    <Previewform file={obj} />
                                </div>
                            ) :
                                null
                        }
                        {
                            Array.isArray(obj.attachments) && obj.attachments.length > 0 && obj.attachments.map((attachment, index) => (
                                <div onClick={() => props.msgAtt(attachment.attachfilename, attachment.oci_status)} key={i++} className={classes.attachment}>
                                    <div>{attachment.attachfilename.split('/').reverse()[0]}</div>
                                </div>
                            ))
                        }
                    </div>
                }
            </div>
        </ScrollToBottom>
    ));

    const deleteMsgAttach = () => {
        props.onFilesChange([]);
    };

    const [openStlview, setOpenStlview] = React.useState(false);
    const [selectedstls, setSelectedstls] = React.useState<GetFileData[]>([]);
    const [selectedstlsString, setSelectedstlsString] = React.useState<string[]>([]);
    const [allStls, setallStls] = React.useState<GetFileData[]>([]);

    const openStlSelect = (files: GetFileData[]) => {
        setallStls(files.filter(r => (r.filetype === 'STL File' && r.filename.split('.').reverse()[0] === 'stl')));
        setOpenStlview(true);
        setSelectedstls([]);
        setSelectedstlsString([]);
    };

    const closeStlSelect = () => {
        setOpenStlview(false);
        setSelectedstls([]);
        setSelectedstlsString([]);
        setallStls([]);
    };

    const onSelectstl = (event: React.ChangeEvent<HTMLInputElement>) => {

        const selectedOld = selectedstls;
        const selectedStringOld = selectedstlsString;

        if (event.target.checked === true) {
            const selected = allStls.filter((stls) => stls.filename === event.target.value);
            selectedOld.push(selected[0]);
            setSelectedstls(selectedOld.filter((stl) => stl.filename !== ''));

            selectedStringOld.push(event.target.value);
            setSelectedstlsString(selectedStringOld.filter((stl) => stl !== ''));
        } else {
            setSelectedstls(selectedstls.filter((stls) => stls.filename !== event.target.value));

            const indexofCheck = selectedstlsString.indexOf(event.target.value);
            selectedstlsString.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setSelectedstlsString(selectedstlsString);
        }
    };

    const submitStlSelect = () => {
        props.goStlViewer(selectedstls);
        setOpenStlview(false);
        setSelectedstls([]);
        setSelectedstlsString([]);
        setallStls([]);
    };

    const [openRe, setOpenRe] = React.useState(false);
    const [openDesignReason, setOpenDesignReason] = React.useState(false);
    const [openModelReason, setOpenModelReason] = React.useState(false);

    const [fullWidth] = React.useState(true);
    const [maxWidth] = React.useState<DialogProps['maxWidth']>('md');

    const [orderno, setOrderno] = React.useState('');
    const [userName, setuserName] = React.useState('');
    const [tat, setTat] = React.useState('Next Day 7 AM');
    const [manufactType, saveManufactType] = React.useState('In-House');

    const [ptype, setPtype] = React.useState('');
    const [ptypeModel, setPtypeModel] = React.useState('');
    const [category, setCategory] = React.useState('');
    const [categoryArray, setCategoryArray] = React.useState<string[]>([]);
    const [categoryModelArray, setCategoryModelArray] = React.useState<string[]>([]);
    const [categoryModel, setCategoryModel] = React.useState('');
    const [reason, setReason] = React.useState<SubitReDesignCodes[]>([]);
    const [reasonModel, setReasonModel] = React.useState<SubitReDesignCodes[]>([]);
    const [msg, setMsg] = React.useState('');

    const duplicateCateDesign = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(id => {
                return data.find(a => a.category === id && a.producttype !== 'Model');
            });
    };

    const duplicateCateModel = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(id => {
                return data.find(a => a.category === id && a.producttype === 'Model');
            });
    };

    const changeDesignCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategory(event.target.value);
            setOpenDesignReason(true);
        } else {
            setReason(reason.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryArray.indexOf(event.target.value);
            categoryArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryArray(categoryArray);
        }
    };
    const changeModelCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategoryModel(event.target.value);
            setOpenModelReason(true);
        } else {
            setReasonModel(reasonModel.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryModelArray.indexOf(event.target.value);
            categoryModelArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryModelArray(categoryModelArray);
        }
    };

    const changeDesignReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArray: SubitReDesignCodes = {
            producttype: 'Design',
            category: category,
            reason: event.target.value
        };
        reason.push(newArray);
        setReason(reason);
        categoryArray.push(category);
        setCategoryArray(categoryArray);
        setOpenDesignReason(false);
    };
    const changeModelReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArrayModel: SubitReDesignCodes = {
            producttype: 'Model',
            category: categoryModel,
            reason: event.target.value
        };
        reasonModel.push(newArrayModel);
        setReasonModel(reasonModel);
        categoryModelArray.push(categoryModel);
        setCategoryModelArray(categoryModelArray);
        setOpenModelReason(false);
    };

    const handleClickOpenRe = () => {
        setMsg('');
        setPtype('Design');
        setPtypeModel('Model');
        setCategory('0');
        setCategoryModel('0');
        setOrderno(props.orderno);
        setuserName(props.lab);
        setTat('Next Day 7 AM');
        saveManufactType(props.destination || '');
        setOpenRe(true);
        setReasonModel([]);
        setReason([]);
        setCategoryModelArray([]);
        setCategoryArray([]);
    };
    const handleCloseRe = () => {
        setOpenRe(false);
    };
    const onCloseDesignReason = () => {
        setOpenDesignReason(false);
    };
    const onCloseModelReason = () => {
        setOpenModelReason(false);
    };
    const [instructionsTabValue, setInstructionsTabValue] = React.useState(0);

    const handleInstructionsTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setInstructionsTabValue(newValue);
    };
    // approval
    const [msgApp, setMsgApp] = React.useState('');
    const [openAppro, setOpenAppro] = React.useState(false);
    const handleClickOpenApp = (ordernumber: string) => {
        setMsgApp('');
        setOrderno(ordernumber);
        setOpenAppro(true);
    };
    const handleCloseApp = () => {
        setOrderno('');
        setOpenAppro(false);
    };
    const handleSubmitApp = () => {
        setOpenAppro(false);
        const array = [{
            orderno: orderno,
            approval_reqd: '1',
            remarks: msgApp.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
        }];
        props.approvalRequired(array);
    };
    const msgAppChange = (msgValue: string) => {
        setMsgApp(msgValue);
    };
    const handleSubmitRe = () => {
        const columns = {
            columns: {
                customer: userName,
                caseno: orderno,
                tat: tat,
                destination: manufactType,
                msg: msg.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
            },
            reasons: reason.concat(reasonModel),
            id: 'rword'
        };
        setOpenRe(false);
        props.redesignRequest(columns);
    };

    const getVideofile = (filesVideo: GetFileData[]) => {
        const filteredFiles = filesVideo.filter(uniquefiles => (uniquefiles.filetype === 'Video'));

        if (filteredFiles.length > 0) {
            return filteredFiles;
        }

        return [];
    };

    const filetypeCaption = (type: string) => {

        if (type === 'Video') {
            return '3D Preview (Video)';
        } else if (type === 'STL File') {
            return 'STL Files';
        }
        return type;

    };

    const fileDetailsTabNs = () => {
        return (
            <div>
                {
                    fileTypes.map((fileType, index) => (
                        fileRender1(fileType) !== 'No Data' ?
                            // <Grid item sm={6} >
                            <Card key={`id_${index}`}>
                                <CardHeaderCssFiles
                                    title={filetypeCaption(fileType)}
                                    action={fileType === 'STL File' ?
                                        <IconButton style={{ padding: '0px' }} color="primary" onClick={() => openStlSelect(props.getFilesData)} aria-label="view stl">
                                            <ThreeDRotationIcon />
                                        </IconButton>
                                        : fileType === 'Video' ?
                                            <IconButton
                                                style={{ padding: '0px' }}
                                                color="primary"
                                                onClick={() => props.openVideoPlayerURL(getVideofile(props.getFilesData))}
                                                aria-label="view video"
                                            >
                                                <PlayCircleFilledTwoToneIcon />
                                            </IconButton>
                                            : null}
                                />
                                <CardContentFiles>
                                    {fileRender1(fileType)}
                                </CardContentFiles>
                            </Card>
                            : null
                    ))
                }
            </div>
        );
    };

    const getMessageTab = () => {
        return (
            <>
                <ScrollToBottom scrollViewClassName={classes.scrollStyleNs} className={classes.containerNs}>{chatBubbles}</ScrollToBottom>
                <div className={classes.formNs}>
                    <Grid container spacing={1}>
                        <Grid item xs={2} className={classes.centerNs}>
                            <Button
                                type="button"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                style={{
                                    background:
                                        '-webkit-linear-gradient(to right, #0083B0, #00B4DB)'
                                }}
                                onClick={props.getMessages}
                            >
                                <RefreshIcon />
                            </Button>
                        </Grid>
                        <Grid item xs={6} className={classes.centerNs}>
                            <TextField
                                variant="outlined"
                                className={classes.textField}
                                margin="dense"
                                fullWidth
                                onChange={event => props.messaging(event.target.value)}
                                label="Messages"
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        props.onSubmit();
                                    }
                                }
                                }
                                value={props.messages}
                            />
                        </Grid>
                        <Grid item xs={2} className={classes.centerNs}>
                            <Button
                                type="button"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                disabled={props.messages === '' && props.messageFiles.length === 0}
                                style={{
                                    background:
                                        '-webkit-linear-gradient(to right, #0083B0, #00B4DB)'
                                }}
                                onClick={props.onSubmit}
                            >
                                Send
                            </Button>
                        </Grid>
                        <Grid item xs={2}>
                            <Files
                                className={classes.fileUpload}
                                onChange={props.onFilesChange}
                                onError={props.onFilesError}
                                accepts={['image/*']}
                                multiple
                                // maxFiles={5}
                                maxFileSize={100000000}
                                minFileSize={0}
                                dropActiveClassName={classes.filesDropzoneActive}
                                clickable
                            >
                                <AttachFileIcon />
                            </Files>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} justify="center" style={{ marginTop: '16px' }} alignItems="center">
                        {
                            props.messageFiles.length > 0 &&
                            <div>
                                Attachments - <strong>{props.messageFiles.map((filenames) => filenames.name).join(', ')}</strong>&nbsp;
                                <Tooltip title="Clear selected attachments" placement="right">
                                    <IconButton aria-label="delete" onClick={deleteMsgAttach}>
                                        <DeleteIcon className={classes.colorDel} fontSize="large" />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </Grid>
                </div>
            </>
        );
    };

    const caseDetailsTab = () => {
        return (
            <div className={classes.tabpanel}>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Design Type</TableCell>
                                <TableCell align="right">Tooth</TableCell>
                                <TableCell align="right">Material</TableCell>
                                <TableCell align="right">Model</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.isArray(props.rxDetails) && props.rxDetails.length > 0 && props.rxDetails.map((rxDetail, iRx) => (
                                <TableRow key={iRx}>
                                    <TableCell component="th" scope="row">
                                        {rxDetail.designtype}
                                    </TableCell>
                                    <TableCell align="right">{rxDetail.notations}</TableCell>
                                    <TableCell align="right">{rxDetail.materialname}</TableCell>
                                    <TableCell align="right">{rxDetail.model}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    };

    const workDoneTab = () => {
        return (
            <div className={classes.tabpanel}>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <Typography variant="body2">
                                        Designer
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <Typography variant="body2">
                                        {props.designername || '-'}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <Typography variant="body2">
                                        Model Designer
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <Typography variant="body2">
                                        {props.mdesignername || '-'}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <Typography variant="body2">
                                        QC
                                    </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <Typography variant="body2">
                                        {props.fqcname || '-'}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    };

    const fileDetailsTab = () => {
        return (
            <div className={classes.tabpanel}>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                        <TableBody>
                            {fileTypes.map((fileType, index) => (
                                fileRender1(fileType) !== 'No Data' ?
                                    <TableRow key={`id_${index}`}>
                                        <TableCell component="th" scope="row">
                                            {filetypeCaption(fileType)}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {fileRender1(fileType)}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {fileType === 'STL File' ?
                                                <IconButton style={{ padding: '0px' }} color="primary" onClick={() => openStlSelect(props.getFilesData)} aria-label="view stl">
                                                    <ThreeDRotationIcon />
                                                </IconButton>
                                                : null}
                                            {fileType === 'Video' ?
                                                <IconButton
                                                    style={{ padding: '0px' }}
                                                    color="primary"
                                                    onClick={() => props.openVideoPlayerURL(getVideofile(props.getFilesData))}
                                                    aria-label="view video"
                                                >
                                                    <PlayCircleFilledTwoToneIcon />
                                                </IconButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    : null
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    };

    const instructionsTab = () => {
        return (
            <Paper>
                <CssTextField
                    id="casenotes"
                    fullWidth
                    disabled
                    multiline
                    rows={10}
                    defaultValue="No Instructions found"
                    variant="outlined"
                    value={props.caseNotes !== '' ? props.caseNotes : 'No Instructions found'}
                />
            </Paper>
        );
    };

    if ((props.userDetails.ugroup === 'Manufacturer' || props.userDetails.ugroup === 'EDDL') && openViewManufactFileRef) {
        props.getFiles();
        setOpenViewManufactFileRef(false);
    }
    console.error(props);

    // new restart and cancel button functions 
    const [newtitleName, setNewTitle] = React.useState('');
    const [newopenDialog, setNewOpen] = React.useState(false);
    const [newmsgApp, setNewMsgApp] = React.useState('');

    const newhandleClickOpen = (title: string) => {
        setNewMsgApp('');
        setNewTitle(title);
        setNewOpen(true);
    };
    const newhandleClose = () => {
        setNewOpen(false);
    };
    const newhandleSubmit = () => {
        setNewOpen(false);
        const columns = {
            columns: {
                caseno: props.orderno,
                ordaction: newtitleName,
                msg: newmsgApp.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
            },
            id: 'ordcr'
        };
        props.submitRework(columns);
        window.history.back();
    };
    const newmsgAppChange = (msgValue: string) => {
        setNewMsgApp(msgValue);
    };
    return (
        <div className={classes.root}>
            <Container component="main" maxWidth={props.verticalViewScreen ? 'lg' : 'md'}>
                <CssBaseline />
                <Card variant="outlined">
                    {props.verticalViewScreen ?
                        <CardHeaderCssNs
                            title="View Order"
                            avatar={
                                <Avatar aria-label="View order" className={classes.avatarNs}>
                                    <ListAltRoundedIcon fontSize="small" />
                                </Avatar>}
                            action={
                                (
                                    (props.status === '10' || props.status === '14') ?
                                        (
                                            (props.status === '10') ?
                                                (
                                                    <>
                                                        {/* <div> */}

                                                        {/* </div> */}
                                                        <span>
                                                            {
                                                                props.vfiles !== '' ?
                                                                    <Button
                                                                        color="primary"
                                                                        onClick={() => props.openVideoPlayerURLArray(props.vfiles.split(','), props.filepath)}
                                                                        size="small"
                                                                        endIcon={<PlayCircleFilledTwoToneIcon />}
                                                                    >
                                                                        3D Preview (Video)
                                                                    </Button>
                                                                    : null
                                                            }
                                                            &nbsp;
                                                            <Button
                                                                color="primary"
                                                                onClick={() => props.supportPage(props.orderno)}
                                                                size="small"
                                                                endIcon={<ThumbsUpDownRoundedIcon />}
                                                            >
                                                                Support
                                                            </Button>
                                                            &nbsp;
                                                            <Button
                                                                color="primary"
                                                                onClick={handleClickOpenRe}
                                                                size="small"
                                                                endIcon={<RedoIcon />}
                                                            >
                                                                Re-Design
                                                            </Button >
                                                            &nbsp;
                                                            <Button
                                                                variant="outlined"
                                                                onClick={props.onFeedback}
                                                                size="small"
                                                                startIcon={<FeedbackOutlinedIcon />}
                                                                className={classes.buttonColor}
                                                            >
                                                                Submit Feedback
                                                            </Button>
                                                        </span>
                                                    </>
                                                ) :
                                                (
                                                    <>
                                                        {/* <div> */}

                                                        {/* </div> */}
                                                        <span>
                                                            {
                                                                props.vfiles !== '' ?
                                                                    <Button
                                                                        color="primary"
                                                                        onClick={() => props.openVideoPlayerURLArray(props.vfiles.split(','), props.filepath)}
                                                                        size="small"
                                                                        endIcon={<PlayCircleFilledTwoToneIcon />}
                                                                    >
                                                                        3D Preview (Video)
                                                                    </Button>
                                                                    : null
                                                            }
                                                            &nbsp;
                                                            <Button
                                                                color="primary"
                                                                onClick={() => props.supportPage(props.orderno)}
                                                                size="small"
                                                                endIcon={<ThumbsUpDownRoundedIcon />}
                                                            >
                                                                Support
                                                            </Button>
                                                            &nbsp;
                                                            <Button
                                                                color="primary"
                                                                onClick={handleClickOpenRe}
                                                                size="small"
                                                                endIcon={<RedoIcon />}
                                                            >
                                                                Re-Design
                                                            </Button>
                                                        </span>
                                                    </>
                                                )
                                        )
                                        :
                                        (
                                            <>
                                                {/* Include the modified code here */}
                                                <>
                                                    {(props.status === '13' && props.customerstatus === 'On Hold') ? (
                                                        <>
                                                            {/*  buttons when status is 13 and customerstatus is On Hold */}
                                                            <Button
                                                                variant="contained"
                                                                color="secondary"
                                                                className={classes.button}
                                                                startIcon={<DeleteIcon />}
                                                                onClick={() => newhandleClickOpen('Cancel')}
                                                            >
                                                                Cancel
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                className={classes.button}
                                                                endIcon={<RestoreIcon />}
                                                                onClick={() => newhandleClickOpen('Restart')}
                                                            >
                                                                Re-start
                                                            </Button>
                                                            <span>
                                                                <Button
                                                                    color="primary"
                                                                    onClick={() => props.supportPage(props.orderno)}
                                                                    size="small"
                                                                    endIcon={<ThumbsUpDownRoundedIcon />}
                                                                >
                                                                    Support
                                                                </Button>
                                                            </span>
                                                        </>
                                                    ) : null}
                                                    {(props.status !== '20' && props.status !== '13') && ( // Do not render if status is 20 or 13
                                                        <>
                                                            {/* buttons when status is not 20 or 13 */}
                                                            <span>
                                                                <Button
                                                                    color="primary"
                                                                    onClick={() => props.supportPage(props.orderno)}
                                                                    size="small"
                                                                    endIcon={<ThumbsUpDownRoundedIcon />}
                                                                >
                                                                    Support
                                                                </Button>
                                                            </span>
                                                        </>
                                                    )}
                                                    {(props.status === '20') && ( //  if status is 20
                                                        <>
                                                            {/* buttons when status is 20 */}
                                                            <span>
                                                                <Button
                                                                    color="primary"
                                                                    onClick={() => props.supportPage(props.orderno)}
                                                                    size="small"
                                                                    endIcon={<ThumbsUpDownRoundedIcon />}
                                                                >
                                                                    Support
                                                                </Button>
                                                            </span>
                                                        </>
                                                    )}
                                                </>
                                            </>
                                        )
                                )
                            }
                        />
                        :
                        <CardHeaderCss
                            title="View Order"
                            avatar={
                                <Avatar aria-label="View order" className={classes.avatar}>
                                    <ListAltRoundedIcon />
                                </Avatar>}
                            action={
                                (
                                    (props.status === '10' || props.status === '14') ?
                                        (
                                            (props.status === '10') ?
                                                (
                                                    <>

                                                        <span>
                                                            {
                                                                props.vfiles !== '' ?
                                                                    <Button
                                                                        color="primary"
                                                                        onClick={() => props.openVideoPlayerURLArray(props.vfiles.split(','), props.filepath)}
                                                                        endIcon={<PlayCircleFilledTwoToneIcon />}
                                                                    >
                                                                        3D Preview (Video)
                                                                    </Button>
                                                                    : null
                                                            }
                                                            &nbsp;
                                                            <Button
                                                                color="primary"
                                                                onClick={() => props.supportPage(props.orderno)}
                                                                endIcon={<ThumbsUpDownRoundedIcon />}
                                                            >
                                                                Support
                                                            </Button>
                                                            &nbsp;
                                                            <Button
                                                                color="primary"
                                                                onClick={handleClickOpenRe}
                                                                endIcon={<RedoIcon />}
                                                            >
                                                                Re-Design
                                                            </Button >
                                                            &nbsp;
                                                            <Button
                                                                variant="outlined"
                                                                onClick={props.onFeedback}
                                                                startIcon={<FeedbackOutlinedIcon />}
                                                                className={classes.buttonColor}
                                                            >
                                                                Submit Feedback
                                                            </Button>
                                                        </span>
                                                    </>
                                                ) :
                                                (
                                                    <>

                                                        <span>
                                                            {
                                                                props.vfiles !== '' ?
                                                                    <Button
                                                                        color="primary"
                                                                        onClick={() => props.openVideoPlayerURLArray(props.vfiles.split(','), props.filepath)}
                                                                        endIcon={<PlayCircleFilledTwoToneIcon />}
                                                                    >
                                                                        3D Preview (Video)
                                                                    </Button>
                                                                    : null
                                                            }
                                                            &nbsp;
                                                            <Button
                                                                color="primary"
                                                                onClick={() => props.supportPage(props.orderno)}
                                                                endIcon={<ThumbsUpDownRoundedIcon />}
                                                            >
                                                                Support
                                                            </Button>
                                                            &nbsp;
                                                            <Button
                                                                color="primary"
                                                                onClick={handleClickOpenRe}
                                                                endIcon={<RedoIcon />}
                                                            >
                                                                Re-Design
                                                            </Button>
                                                        </span>
                                                    </>
                                                )
                                        ) :
                                        (
                                            (props.status !== '20') &&
                                            (
                                                <>

                                                    <span>
                                                        <Button
                                                            color="primary"
                                                            onClick={() => props.supportPage(props.orderno)}
                                                            size="small"
                                                            endIcon={<ThumbsUpDownRoundedIcon />}
                                                        >
                                                            Support
                                                        </Button>
                                                    </span>
                                                </>
                                            )
                                        )
                                )
                            }
                        />
                    }
                    {
                        props.verticalViewScreen ?
                            <Grid container spacing={2}>
                                <Grid item md={7} sm={12}>
                                    <div className={classes.paperNs}>
                                        <form className={classes.formNs} noValidate>
                                            <Grid container spacing={1} className={classes.cardFieldsNs}>
                                                <Grid item xs={12} sm={3}>
                                                    <div style={{ position: 'relative' }}>
                                                        <CssTextField
                                                            size="small"
                                                            fullWidth
                                                            label="Order No"
                                                            disabled
                                                            value={props.orderno}
                                                        />
                                                        {props.qc_required === '1' ? (
                                                            <div className={classes.qcreq}>
                                                                QC Required
                                                            </div>
                                                        ) : props.qc_required === '2' ? (
                                                            <div className={classes.qcreq} onClick={() => handleClickOpenApp(props.orderno)} style={{ color: 'green', cursor: 'pointer' }}>
                                                                Approve
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </Grid>
            
                                                <Grid item xs={6} sm={3}>
                                                    <CssTextField
                                                        size="small"
                                                        fullWidth
                                                        label="Received On"
                                                        disabled
                                                        value={props.createddate}
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <CssTextField
                                                        size="small"
                                                        fullWidth
                                                        label="Due By"
                                                        disabled
                                                        value={props.duedate}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <CssTextField
                                                            size="small"
                                                            fullWidth
                                                            label="Status"
                                                            disabled
                                                            value={props.customerstatus}
                                                        />
                                                        {(props.userDetails.ugroup === 'Lab' && (props.status === '10' || props.status === '14')) ?
                                                            (
                                                                (props.fdownload === '' || props.fdownload === '0') ?
                                                                    <Tooltip title="Not yet Downloaded" placement="top">
                                                                        <div className={classes.downloadStatusIconRed} />
                                                                    </Tooltip>
                                                                    :
                                                                    props.downloadedon ? (
                                                                        <Tooltip title={`Last Downloaded on - ${props.downloadedon}`} placement="top">
                                                                            <div className={classes.downloadStatusIconGreen} />
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <Tooltip title="Downloaded" placement="top">
                                                                            <div className={classes.downloadStatusIconGreen} />
                                                                        </Tooltip>
                                                                    )
                                                            )
                                                            :
                                                            null
                                                        }

                                                    </div>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <CssTextField
                                                        size="small"
                                                        fullWidth
                                                        label="File Name"
                                                        disabled
                                                        value={props.filename}
                                                    />
                                                </Grid>
                                                {/* <Grid item xs={12} sm={6}>
                                                    <CssTextField
                                                        size="small"
                                                        fullWidth
                                                        label="Booking ID"
                                                        disabled
                                                        value={props.refno}
                                                    />
                                                </Grid> */}
                                                <Grid item xs={6} sm={4}>
                                                    <CssTextField
                                                        size="small"
                                                        fullWidth
                                                        label="Software Used"
                                                        style={{ textAlign: 'center' }}
                                                        disabled
                                                        value={props.tool_preferred === '' ? '-' : props.tool_preferred}
                                                    />
                                                </Grid>
                                                {
                                                    (props.status === '10' || props.status === '14') && <Grid item xs={6} sm={4}>
                                                        <CssTextField
                                                            size="small"
                                                            fullWidth
                                                            label="Completed On"
                                                            style={{ textAlign: 'center' }}
                                                            disabled
                                                            value={props.completedon || ''}
                                                        />
                                                    </Grid>}
                                                {(props.userDetails.ugroup === 'Manufacturer' || props.userDetails.ugroup === 'EDDL') ?
                                                    <Grid item xs={12} sm={4}>
                                                        <CssTextField
                                                            size="small"
                                                            fullWidth
                                                            label="Lab"
                                                            disabled
                                                            value={props.lab}
                                                        />
                                                    </Grid>
                                                    :
                                                    <Grid item xs={12} sm={4}>
                                                        <CssTextField
                                                            size="small"
                                                            fullWidth
                                                            label="Destination"
                                                            disabled
                                                            value={props.destination}
                                                        />
                                                    </Grid>}
                                                <Grid item xs={6} sm={4}>
                                                    <CssTextField
                                                        size="small"
                                                        fullWidth
                                                        label="Model Only"
                                                        style={{ textAlign: 'center' }}
                                                        disabled
                                                        value={props.modelonly === 'Y' ? 'Yes' : 'No'}
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={4}>
                                                    <CssTextField
                                                        size="small"
                                                        fullWidth
                                                        label="Design Approval"
                                                        style={{ textAlign: 'center' }}
                                                        disabled
                                                        value={props.designapproval === '1' ? 'Required' : 'No'}
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={4}>
                                                    <CssTextField
                                                        size="small"
                                                        fullWidth
                                                        label="Bravo / Premium"
                                                        style={{ textAlign: 'center' }}
                                                        disabled
                                                        value={props.bravo === '1' ? 'Yes' : 'No'}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </form>
                                    </div>
                                    <Card variant="outlined" className={classes.cardMarginNs}>
                                        <CardHeaderCssInside
                                            title="Case Details"
                                        />
                                        <Divider />
                                        <TableContainer component={Paper} className={classes.tableContainerNs}>
                                            <Table className={classes.table} size="small" aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Design Type</TableCell>
                                                        <TableCell align="right">Tooth</TableCell>
                                                        <TableCell align="right">Material</TableCell>
                                                        <TableCell align="right">Model</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {Array.isArray(props.rxDetails) && props.rxDetails.length > 0 && props.rxDetails.map((rxDetail, iRx) => (
                                                        <TableRow key={iRx} className={classes.tableRowNs}>
                                                            <TableCell component="th" scope="row">
                                                                {rxDetail.designtype}
                                                            </TableCell>
                                                            <TableCell align="right">{rxDetail.notations}</TableCell>
                                                            <TableCell align="right">{rxDetail.materialname}</TableCell>
                                                            <TableCell align="right">{rxDetail.model}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Card>
                                    <Card variant="outlined" className={classes.cardMarginNs}>
                                        <CardHeaderCssInside
                                            title="Files"
                                        />
                                        <Divider />
                                        <div>
                                            {fileDetailsTabNs()}
                                        </div>
                                    </Card>
                                    <Card variant="outlined" className={classes.cardMarginNs}>
                                        <CardHeaderCssInside
                                            title="Work Done By"
                                        // subheader={props.status}
                                        />
                                        <Divider />
                                        <Grid container spacing={1} className={classes.paperNs}>
                                            <Grid item xs={6} sm={4}>
                                                <CssTextField
                                                    size="small"
                                                    fullWidth
                                                    label="Designer"
                                                    style={{ textAlign: 'center' }}
                                                    disabled
                                                    value={props.designername || '-'}
                                                />
                                            </Grid>
                                            <Grid item xs={6} sm={4}>
                                                <CssTextField
                                                    size="small"
                                                    fullWidth
                                                    label="Model Designer"
                                                    style={{ textAlign: 'center' }}
                                                    disabled
                                                    value={props.mdesignername || '-'}
                                                />
                                            </Grid>
                                            <Grid item xs={6} sm={4}>
                                                <CssTextField
                                                    size="small"
                                                    fullWidth
                                                    label="QC"
                                                    style={{ textAlign: 'center' }}
                                                    disabled
                                                    value={props.fqcname || '-'}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                                <Grid item md={5} sm={12}>
                                    {/* <Card variant="outlined" className={classes.cardMargin2Ns}>
                                         <CardHeaderCssInside title="Instructions & Preferences" />
                                        <Divider />
                                        <CssTextField
                                            style={{ borderColor: '#fff' }}
                                            id="casenotes"
                                            fullWidth
                                            disabled
                                            multiline
                                            InputProps={{
                                                classes: {
                                                    root: classes.cssOutlinedInput
                                                }
                                            }}
                                            rows={10}
                                            defaultValue="No Instructions found"
                                            variant="outlined"
                                            value={props.caseNotes !== '' ? props.caseNotes : 'No Instructions found'}
                                        />
                                    </Card> */}
                                    <Card variant="outlined" className={classes.cardMargin2Ns}>
                                    <CardHeaderCssInside title="Instructions & Preferences" />
                                    <Tabs
                                        value={instructionsTabValue}
                                        onChange={handleInstructionsTabChange}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        variant="fullWidth"
                                    >
                                        <Tab label="Instructions" />
                                        <Tab label="Preferences" />
                                    </Tabs>
                                    <Divider />
                                    {instructionsTabValue === 0 && (
                                        <Paper className={classes.tabPanel}>
                                        <CssTextField
                                            id="casenotes"
                                            fullWidth
                                            disabled
                                            multiline
                                            rows={10}
                                            defaultValue="No Instructions found"
                                            variant="outlined"
                                            value={props.caseNotes !== '' && props.caseNotes ? props.caseNotes : 'No Instructions found'}
                                        />
                                        </Paper>
                                    )}
                                    {/* {instructionsTabValue === 1 && (
                                        <Paper className={classes.tabPanel}>
                                        <CssTextField
                                            id="drPreferences"
                                            fullWidth
                                            disabled
                                            multiline
                                            rows={10}
                                            defaultValue="No Dr. Preferences found"
                                            variant="outlined"
                                            value={
                                              props.drpref !== '' && props.drpref ? props.drpref : 'No Dr. Preferences found'
                                            }
                                        />
                                        </Paper>
                                    )} */}
                                    {/* {instructionsTabValue === 1 && (
                                        <Paper className={classes.tabPanel}>
                                            {props.drpref ? (
                                                <div
                                                    className={classes.drPreferencesContent}
                                                    dangerouslySetInnerHTML={{
                                                        __html: DOMPurify.sanitize(props.drpref),
                                                    }}
                                                />
                                            ) : (
                                                <div className={classes.drPreferencesContent}>
                                                    No Preferences found
                                                </div>
                                            )}
                                        </Paper>
                                    )} */}
                                    {instructionsTabValue === 1 && (
                                        <Paper className={classes.tabPanel}>
                                            {props.drpref ? (
                                                <div
                                                    className={classes.drPreferencesContent}
                                                    dangerouslySetInnerHTML={{
                                                        __html: sanitizedDrpref,
                                                    }}
                                                />
                                            ) : (
                                                <div className={classes.drPreferencesContent}>
                                                    No Preferences found
                                                </div>
                                            )}
                                        </Paper>
                                    )}
                                    </Card>
                                    <Card variant="outlined" className={classes.cardMargin2Ns}>
                                        <CardHeaderCssInside
                                            title="Messaging"
                                        />
                                        <Divider />
                                        {getMessageTab()}
                                    </Card>
                                </Grid>
                            </Grid>
                            :
                            <div className={classes.paper}>
                                <form className={classes.form} noValidate>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={3}>
                                            <div style={{ position: 'relative' }}>
                                                <CssTextField
                                                    size="small"
                                                    fullWidth
                                                    label="Order No"
                                                    disabled
                                                    value={props.orderno}
                                                />
                                                {props.qc_required === '1' ? (
                                                    <div className={classes.qcreq}>
                                                        QC Required
                                                    </div>
                                                ) : props.qc_required === '2' ? (
                                                    <div className={classes.qcreq} onClick={() => handleClickOpenApp(props.orderno)} style={{ color: 'green', cursor: 'pointer' }}>
                                                        Approve
                                                    </div>
                                                ) : null}
                                            </div>
                                        </Grid>
                                       
                                        <Grid item xs={6} sm={3}>
                                            <CssTextField
                                                size="small"
                                                fullWidth
                                                label="Received On"
                                                disabled
                                                value={props.createddate}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={3}>
                                            <CssTextField
                                                size="small"
                                                fullWidth
                                                label="Due By"
                                                disabled
                                                value={props.duedate}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <CssTextField
                                                    size="small"
                                                    fullWidth
                                                    label="Status"
                                                    disabled
                                                    value={props.customerstatus}
                                                />
                                                {(props.userDetails.ugroup === 'Lab' && (props.status === '10' || props.status === '14')) ?
                                                    (
                                                        (props.fdownload === '' || props.fdownload === '0') ?
                                                            <Tooltip title="Not yet Downloaded" placement="top">
                                                                <div className={classes.downloadStatusIconRed} />
                                                            </Tooltip>
                                                            :
                                                            props.downloadedon ? (
                                                                <Tooltip title={`Last Downloaded on - ${props.downloadedon}`} placement="top">
                                                                    <div className={classes.downloadStatusIconGreen} />
                                                                </Tooltip>
                                                            ) : (
                                                                <Tooltip title="Downloaded" placement="top">
                                                                    <div className={classes.downloadStatusIconGreen} />
                                                                </Tooltip>
                                                            )
                                                    )
                                                    :
                                                    null
                                                }

                                            </div>
                                        </Grid>
                                        <Grid item xs={12} sm={(props.status === '10' || props.status === '14') ? 8 : 10}>
                                            <CssTextField
                                                size="small"
                                                fullWidth
                                                label="File Name"
                                                disabled
                                                value={props.filename}
                                            />
                                        </Grid>
                                         {/* <Grid item xs={12} sm={6}>
                                            <CssTextField
                                                size="small"
                                                fullWidth
                                                label="Booking ID"
                                                disabled
                                                // value={props.bookingId || ''}
                                            />
                                        </Grid> */}
                                        <Grid item xs={6} sm={2}>
                                            <CssTextField
                                                size="small"
                                                fullWidth
                                                label="Software Used"
                                                style={{ textAlign: 'center' }}
                                                disabled
                                                value={props.tool_preferred === '' ? '-' : props.tool_preferred}
                                            />
                                        </Grid>
                                        {
                                            (props.status === '10' || props.status === '14') && <Grid item xs={6} sm={2}>
                                                <CssTextField
                                                    size="small"
                                                    fullWidth
                                                    label="Completed On"
                                                    style={{ textAlign: 'center' }}
                                                    disabled
                                                    value={props.completedon || ''}
                                                />
                                            </Grid>}
                                        {(props.userDetails.ugroup === 'Manufacturer' || props.userDetails.ugroup === 'EDDL') ?
                                            <Grid item xs={12} sm={3}>
                                                <CssTextField
                                                    size="small"
                                                    fullWidth
                                                    label="Lab"
                                                    disabled
                                                    value={props.lab}
                                                />
                                            </Grid>
                                            :
                                            <Grid item xs={12} sm={3}>
                                                <CssTextField
                                                    size="small"
                                                    fullWidth
                                                    label="Destination"
                                                    disabled
                                                    value={props.destination}
                                                />
                                            </Grid>}
                                        <Grid item xs={6} sm={3}>
                                            <CssTextField
                                                size="small"
                                                fullWidth
                                                label="Model Only"
                                                style={{ textAlign: 'center' }}
                                                disabled
                                                value={props.modelonly === 'Y' ? 'Yes' : 'No'}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={3}>
                                            <CssTextField
                                                size="small"
                                                fullWidth
                                                label="Design Approval"
                                                style={{ textAlign: 'center' }}
                                                disabled
                                                value={props.designapproval === '1' ? 'Required' : 'No'}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={3}>
                                            <CssTextField
                                                size="small"
                                                fullWidth
                                                label="Bravo / Premium"
                                                style={{ textAlign: 'center' }}
                                                disabled
                                                value={props.bravo === '1' ? 'Yes' : 'No'}
                                            />
                                        </Grid>
                                    </Grid>
                                </form>
                            </div>
                    }
                </Card>
                {!props.verticalViewScreen && <AppBar position="static" className={classes.tableMargin} color="default">
                    <Tabs
                        variant="fullWidth"
                        value={value}
                        onChange={handleChange}
                        aria-label="nav tabs example"
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <AntTab icon={<BusinessCenterOutlinedIcon />} label="Case Details" {...a11yProps(0)} />
                        <AntTab icon={<DescriptionOutlinedIcon />} label="Files"  {...a11yProps(1)} />
                        <AntTab icon={<DirectionsIcon />} label="Instructions"  {...a11yProps(2)} />
                        <AntTab className={classes.chatBotWidth} icon={<MessageOutlinedIcon />} label="Messages" {...a11yProps(3)} />
                        <AntTab icon={<PeopleAltIcon />} label="Work Done By"  {...a11yProps(4)} />
                    </Tabs>
                </AppBar>}
                {
                    !props.verticalViewScreen &&
                    <TabPanel value={value} index={0}>
                        {caseDetailsTab}
                    </TabPanel>
                }
                <TabPanel value={value} index={1}>
                    {fileDetailsTab}
                </TabPanel>
                <TabPanel value={value} index={2}>
                    {instructionsTab}
                </TabPanel>
                <TabPanel value={value} index={4}>
                    {workDoneTab}
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <ScrollToBottom className={classes.container}>{chatBubbles}</ScrollToBottom>
                    <div className={classes.form}>
                        <Grid container spacing={2}>
                            <Grid item xs={2}>
                                <Button
                                    type="button"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    style={{
                                        background:
                                            '-webkit-linear-gradient(to right, #0083B0, #00B4DB)'
                                    }}
                                    onClick={props.getMessages}
                                >
                                    <RefreshIcon />
                                </Button>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    variant="outlined"
                                    className={classes.textField}
                                    margin="dense"
                                    fullWidth
                                    autoFocus
                                    onChange={event => props.messaging(event.target.value)}
                                    label="Messages"
                                    onKeyPress={event => {
                                        if (event.key === 'Enter') {
                                            props.onSubmit();
                                        }
                                    }
                                    }
                                    value={props.messages}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Button
                                    type="button"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    disabled={props.messages === '' && props.messageFiles.length === 0}
                                    style={{
                                        background:
                                            '-webkit-linear-gradient(to right, #0083B0, #00B4DB)'
                                    }}
                                    onClick={props.onSubmit}
                                >
                                    Send
                                </Button>
                            </Grid>
                            <Grid item xs={2}>
                                <Files
                                    className={classes.fileUpload}
                                    onChange={props.onFilesChange}
                                    onError={props.onFilesError}
                                    accepts={['image/*', 'video/*', 'audio/*', '.pdf']}
                                    multiple
                                    // maxFiles={5}
                                    maxFileSize={100000000}
                                    minFileSize={0}
                                    dropActiveClassName={classes.filesDropzoneActive}
                                    clickable
                                >
                                    <AttachFileIcon />
                                </Files>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} justify="center" style={{ marginTop: '16px' }} alignItems="center">
                            {
                                props.messageFiles.length > 0 &&
                                <div>
                                    Attachments - <strong>{props.messageFiles.map((filenames) => filenames.name).join(', ')}</strong>&nbsp;
                                    <Tooltip title="Clear selected attachments" placement="right">
                                        <IconButton aria-label="delete" onClick={deleteMsgAttach}>
                                            <DeleteIcon className={classes.colorDel} fontSize="large" />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            }
                        </Grid>
                    </div>
                </TabPanel>
                <Dialog
                    open={openRe}
                    aria-labelledby="Dialog-Order-Redesign"
                    fullWidth={fullWidth}
                    maxWidth={maxWidth}
                >
                    <DialogTitle id="form-dialog-title">Re-Design Request on Order No : {orderno}</DialogTitle>
                    <DialogContent dividers>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} md={4}>
                                {/* <FormControl size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined"
                                                defaultValue="0"
                                                onChange={(event) => setPtype(event.target.value as string)}
                                                value={ptype}
                                            >
                                                <MenuItem value="Design" disabled>Design</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicatePtype(props.redesignReasons).map((proType, indexRe1) => (
                                                    proType!.producttype !== 'Model' ? <MenuItem id={proType!.rowno} value={proType!.producttype}>{proType!.producttype}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                                <CssTextField
                                    fullWidth
                                    disabled
                                    size="small"
                                    onChange={(event) => setPtype(event.target.value as string)}
                                    value={ptype}
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-1"
                                                defaultValue="0"
                                                onChange={(event) => setCategory(event.target.value as string)}
                                                value={category}
                                            >
                                                <MenuItem value="0" disabled>Select Category</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicateCate(props.redesignReasons).map((cate, indexRe1) => (
                                                    cate!.producttype !== 'Model' ? <MenuItem id={cate!.rowno} value={cate!.category}>{cate!.category}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                            {
                                duplicateCateDesign(props.redesignReasons).map((cate, indexRe1) => (
                                    typeof (cate) === 'object' && cate!.producttype !== 'Model' ?
                                        <Grid item key={indexRe1} xs={12} sm={6} md={3}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        id={`category${indexRe1}`}
                                                        checked={categoryArray.indexOf(cate!.category) !== -1 ? true : false}
                                                        value={cate!.category}
                                                        onChange={changeDesignCategory}
                                                        name="category"
                                                    />
                                                }
                                                label={<Typography variant="caption">{cate!.category}</Typography>}
                                            />
                                        </Grid>
                                        : null
                                ))
                            }

                        </Grid>
                        <hr style={{ margin: '10px 0' }} />
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} md={4}>
                                {/* <FormControl size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-3"
                                                defaultValue="0"
                                                onChange={(event) => setPtypeModel(event.target.value as string)}
                                                value={ptypeModel}
                                            >
                                                <MenuItem value="Model" disabled>Model</MenuItem>
                                            </Select>
                                        </FormControl> */}
                                <CssTextField
                                    fullWidth
                                    disabled
                                    size="small"
                                    onChange={(event) => setPtypeModel(event.target.value as string)}
                                    value={ptypeModel}
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-4"
                                                defaultValue="0"
                                                onChange={(event) => setCategoryModel(event.target.value as string)}
                                                value={categoryModel}
                                            >
                                                <MenuItem value="0" disabled>Select Category (Model)</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicateCate(props.redesignReasons).map((cateModel, indexRe1) => (
                                                    cateModel!.producttype === 'Model' ? <MenuItem id={cateModel!.rowno} value={cateModel!.category}>{cateModel!.category}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                            {
                                duplicateCateModel(props.redesignReasons).map((cateModel, indexRe1) => (
                                    typeof (cateModel) === 'object' && cateModel!.producttype === 'Model' ?
                                        <Grid item key={indexRe1} xs={12} sm={6} md={3}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        id={`categoryModel${indexRe1}`}
                                                        checked={categoryModelArray.indexOf(cateModel!.category) !== -1 ? true : false}
                                                        value={cateModel!.category}
                                                        onChange={changeModelCategory}
                                                        name="category"
                                                    />
                                                }
                                                label={<Typography variant="caption">{cateModel!.category}</Typography>}
                                            />
                                        </Grid>
                                        : null
                                ))
                            }
                        </Grid>
                        <hr style={{ margin: '10px 0' }} />
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl variant="outlined" size="small" className={classes.forms}>
                                    <Select
                                        id="demo-simple-select-outlined-6"
                                        defaultValue="Next Day 7 AM"
                                        onChange={(event) => setTat(event.target.value as string)}
                                        value={tat}
                                    >
                                        {Array.isArray(props.orderDataTat) && props.orderDataTat.length > 0 && props.orderDataTat.map((tatime, index1) => (
                                            <MenuItem key={index1} id={tatime.rowno} value={tatime.tattype}>{tatime.tattype}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl variant="outlined" size="small" className={classes.forms}>
                                    <Select
                                        labelId="demo-simple-select-outlined-label-red1"
                                        id="demo-simple-select-outlined-red1"
                                        required
                                        fullWidth
                                        onChange={(event) => saveManufactType(event.target.value as string)}
                                        value={manufactType}
                                    >
                                        <MenuItem disabled value="">
                                            <em>Destination</em>
                                        </MenuItem>
                                        <MenuItem value="In-House">
                                            In-House
                                        </MenuItem>
                                        {Array.isArray(props.orderDataManufacturer) && props.orderDataManufacturer.length > 0 && props.orderDataManufacturer.map((manufactTypes) => (
                                            <MenuItem id={manufactTypes.rowno} value={manufactTypes.dest}>{manufactTypes.dest}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4}>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <TextField
                                        variant="outlined"
                                        label="Remarks"
                                        multiline
                                        // rows={3}
                                        rowsMax={5}
                                        size="small"
                                        onChange={(event) => setMsg(event.target.value as string)}
                                        value={msg}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ justifyContent: 'space-between' }}>
                        <Typography variant="caption">
                            *Please select Reason, TAT, Destination and enter Remarks to submit Re-Design.
                        </Typography>
                        <div>
                            <Button size="small" onClick={handleCloseRe} color="secondary">
                                Cancel
                            </Button>
                            <Button
                                size="small"
                                disabled={(msg === '' || (reason.length === 0 && reasonModel.length === 0)) ? true : false}
                                onClick={handleSubmitRe}
                                color="primary"
                            >
                                Re-Design
                            </Button>
                        </div>
                    </DialogActions>

                </Dialog>
                <Dialog
                    open={openDesignReason}
                    onClose={onCloseDesignReason}
                >
                    <DialogTitle id="form-dialog-title-reasons">{category} :</DialogTitle>
                    <DialogContent dividers>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12}>
                                <div className={classes.reasonBox}>
                                    <FormControl variant="outlined" fullWidth className={classes.forms}>
                                        <Select
                                            id="demo-simple-select-outlined-2"
                                            defaultValue="0"
                                            fullWidth
                                            onChange={changeDesignReason}
                                            value="0"
                                        >
                                            <MenuItem value="0" disabled>Select Reason</MenuItem>
                                            {Array.isArray(props.redesignReasons)
                                                && props.redesignReasons.length > 0
                                                && props.redesignReasons.map((reasonsRe, indexRe1) => (
                                                    reasonsRe.producttype !== 'Model' && reasonsRe.category === category ?
                                                        <MenuItem key={indexRe1} id={reasonsRe.rowno} value={reasonsRe.code}>{reasonsRe.codedesc}</MenuItem>
                                                        :
                                                        null
                                                ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={openModelReason}
                    onClose={onCloseModelReason}
                >
                    <DialogTitle id="form-dialog-title-reasons">{categoryModel} :</DialogTitle>
                    <DialogContent dividers>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12}>
                                <div className={classes.reasonBox}>
                                    <FormControl variant="outlined" fullWidth className={classes.forms}>
                                        <Select
                                            id="demo-simple-select-outlined-5"
                                            defaultValue="0"
                                            fullWidth
                                            onChange={changeModelReason}
                                            value="0"
                                        >
                                            <MenuItem value="0" disabled>Select Reason (Model)</MenuItem>
                                            {Array.isArray(props.redesignReasons)
                                                && props.redesignReasons.length > 0
                                                && props.redesignReasons.map((reasonsModl, indexRe1) => (
                                                    reasonsModl.producttype === 'Model' && reasonsModl.category === categoryModel ?
                                                        <MenuItem key={indexRe1} id={reasonsModl.rowno} value={reasonsModl.code}>{reasonsModl.codedesc}</MenuItem>
                                                        :
                                                        null
                                                ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={openStlview}
                    onClose={closeStlSelect}
                >
                    <DialogTitle id="form-dialog-title-reasons">Select STL files to be viewed</DialogTitle>
                    <DialogContent dividers>
                        <Grid container spacing={2}>
                            <div className={classes.reasonBox}>
                                {
                                    allStls.map((stls, indexStls) => (
                                        <Grid item xs={12} sm={12} md={12}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        id={`selectedstls${indexStls}`}
                                                        onChange={onSelectstl}
                                                        checked={selectedstlsString.indexOf(stls.filename) !== -1 ? true : false}
                                                        value={stls.filename}
                                                        name="category"
                                                    />
                                                }
                                                label={stls.filename.split('/').reverse()[0]}
                                            />
                                        </Grid>
                                    ))
                                }
                            </div>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button size="small" onClick={closeStlSelect} color="secondary">
                            Cancel
                        </Button>
                        <Button
                            size="small"
                            onClick={submitStlSelect}
                            disabled={selectedstls.length > 0 ? false : true}
                            color="primary"
                        >
                            View STLs
                        </Button>
                    </DialogActions>
                </Dialog>
                {/* APPROVAL */}
                <Dialog
                    open={openAppro}
                    onClose={handleCloseApp}
                    aria-labelledby="Dialog-Order-Redesign"
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle id="form-dialog-title">Approve Design on Order No : {orderno}</DialogTitle>
                    <DialogContent dividers>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <TextField
                                        variant="outlined"
                                        label="Remarks"
                                        multiline
                                        rows={3}
                                        rowsMax={5}
                                        size="small"
                                        onChange={(event) => msgAppChange(event.target.value as string)}
                                        value={msgApp}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button size="small" onClick={handleCloseApp} color="secondary">
                            Cancel
                        </Button>
                        <Button size="small" onClick={handleSubmitApp} disabled={msgApp === ''} color="primary">
                            Approve
                        </Button>
                    </DialogActions>
                </Dialog>
                {/* Newly added rework and cancel buttons */}
                <Dialog
                    open={newopenDialog}
                    onClose={newhandleClose}
                    fullWidth
                    maxWidth="sm"
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{`${newtitleName}`}</DialogTitle>
                    <DialogContent dividers>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure to {`${newtitleName}`} this Order ?
                            <div className={classes.textArea}>
                                <TextField
                                    id="outlined-multiline-static"
                                    label="Remarks"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    autoFocus
                                    // defaultValue="Default Value"
                                    variant="outlined"
                                    onChange={(event) => newmsgAppChange(event.target.value as string)}
                                    value={newmsgApp}
                                />
                            </div>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={newhandleClose} color="primary">
                            No
                        </Button>
                        <Button onClick={newhandleSubmit} disabled={newmsgApp === ''} color="primary" autoFocus>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </div >
    );
};
export default RxorderFormView;



// WEBPACK FOOTER //
// ./src/components/layouts/RxOrderForm.tsx